import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Text from '../../../../shared/_TBComponents/Text';

const CheckEmailContainer = styled('div')`
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  padding: 60px 48px;
  text-align: center;
  width: 440px;
`;

const PasswordNeeded = ({ emailAddress }) => (
  <CheckEmailContainer>
    <Text
      styledTextProps={{
        fontSize: '34px',
        fontWeight: '700',
      }}
    >
      Check your email to set a password and finish signing up
    </Text>
    <Text
      styledTextProps={{
        fontSize: '19px',
        fontWeight: '400',
      }}
    >
      Your account is ready, except for one thing:
      you still need to set a password. We&apos;ve sent the link to
      {' '}
      <b>{emailAddress}</b>
    </Text>
  </CheckEmailContainer>
);

PasswordNeeded.propTypes = {
  emailAddress: PropTypes.string.isRequired,
};

export default PasswordNeeded;
